<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5 class="odx-title-5" i18n="@@signalElementConfiguration.header">Leuchttransparent auswählen</h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (filteredSignalElements$ | async; as signalElements) {
      @if (signalElements.length > 0) {
        <form [formGroup]="signalElementForm" class="h-100 overflow-hidden">
          <odx-radio-group formControlName="selectedSignalElement" required="true">
            <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
              @for (signalElement of signalElements; track signalElement) {
                <app-product-card
                  class="overflow-hidden"
                  [product]="signalElement"
                  [showCosts]="project.showCostFlag"
                  [isSelected]="selectedSignalElement?.id === signalElement.id"
                  (click)="select(signalElement)"
                  (select$)="select(signalElement)"
                  selectionMode="single"
                >
                  @if (signalElement.id) {
                    <div class="feature">
                      <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                      <p class="odx-text--small">{{ signalElement.id }}</p>
                    </div>
                  }
                </app-product-card>
              }
            </div>
          </odx-radio-group>
        </form>
      } @else {
        <app-refresh-products-hint
          dataType="Leuchttransparente"
          i18n-dataType="@@global.signalElements"
        ></app-refresh-products-hint>
      }
    }
  </odx-content-box>
</div>
